/* eslint-disable max-lines */
import { runInAction, toJS } from 'mobx';
import { merge } from 'bernie-core';
import { getErrorString, NOOP_LOGGER } from 'bernie-logger';
import { SOURCE_EVENTS } from './source-events';
var withoutKeys = merge.withoutKeys;
var BexApiSource = /** @class */function () {
  function BexApiSource(api, logger) {
    if (logger === void 0) {
      logger = NOOP_LOGGER;
    }
    this.api = api;
    this.logger = logger;
  }
  BexApiSource.prototype.activityDestinationViewSearch = function (variables, pageId, traceId, messageId) {
    return this.api.ActivityDestinationViewSearch(variables || {}, {
      'x-page-id': pageId,
      traceId: traceId,
      messageId: messageId
    }).catch(this.getErrorHandler(variables, SOURCE_EVENTS.BEX_API_SEARCH_ERROR));
  };
  BexApiSource.prototype.activityDetailBasic = function (variables, pageId, traceId, messageId) {
    return this.api.ActivityDetailBasic(variables || {}, {
      'x-page-id': pageId,
      traceId: traceId,
      messageId: messageId
    }).catch(this.getErrorHandler(variables, SOURCE_EVENTS.BEX_API_SEARCH_ERROR));
  };
  BexApiSource.prototype.activityDetailOffersWithAvailability = function (variables, pageId, traceId, messageId) {
    return this.api.ActivityDetailBasic(variables || {}, {
      'x-page-id': pageId,
      traceId: traceId,
      messageId: messageId
    }).catch(this.getErrorHandler(variables, SOURCE_EVENTS.BEX_API_SEARCH_ERROR));
  };
  BexApiSource.prototype.activityPageSeoContent = function (variables, pageId, traceId, messageId) {
    return this.api.ActivityPageSeoContent(variables || {}, {
      'x-page-id': pageId,
      traceId: traceId,
      messageId: messageId
    }).catch(this.getErrorHandler(variables, SOURCE_EVENTS.BEX_API_SEARCH_ERROR));
  };
  BexApiSource.prototype.getErrorHandler = function (variables, sourceEvent) {
    var _this = this;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return function (error) {
      runInAction('recovering from bex api activities search call breakdown', function () {
        _this.logger.logEvent(sourceEvent, variables, getErrorString(error));
      });
      throw error;
    };
  };
  /**
   * Override the default `toJson` to exclude the Apollo client.
   * If we don't include this, we will get a JSON serialization error.
   *
   * Creates a basic JSON object from the store, excluding
   * any fields provided in `ignoreAdditionalKeys`.
   */
  BexApiSource.prototype.toJSON = function (ignoreAdditionalKeys) {
    if (ignoreAdditionalKeys === void 0) {
      ignoreAdditionalKeys = [];
    }
    if (!Array.isArray(ignoreAdditionalKeys)) {
      ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
    }
    var regexIgnorePrivate = /^_.+/;
    var simpleObject = toJS(this);
    var ignoreKeys = Object.keys(simpleObject).filter(function (key) {
      return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function';
    }).concat(ignoreAdditionalKeys, 'logger', 'api', 'headers', 'apiWithFederation');
    return withoutKeys(ignoreKeys).merge({}, simpleObject);
  };
  return BexApiSource;
}();
export { BexApiSource };